import { SortOption } from "@search";
import { Value } from "../base/utils";
import { ConsultantCardFragment, ConsultantSelector_GetValue } from "@graphql";

export type Consultant = ConsultantSelector_GetValue.Return["consultantById"];

export type SearchFilter = {
  areasOfExpertise: string[];
  text: string;
  sort: SortOption;
};

export const initialFilter: SearchFilter = {
  areasOfExpertise: [],
  text: "",
  sort: "name_asc"
};

export interface SingleProps extends BaseProps {
  multi?: false;
  value?: Value | null;
  onChange: (v: ConsultantCardFragment | null) => void;
}

export interface MultiProps extends BaseProps {
  multi: true;
  value?: Value[];
  onChange: (v: ConsultantCardFragment[]) => void;
}

export type Props = MultiProps | SingleProps;

interface BaseProps {
  clearable?: boolean; // true by default
  disabled?: boolean;
  disabledFilterFields?: Array<keyof SearchFilter>;
  error?: string;
  fullWidth?: boolean;
  helperText?: React.ReactNode;
  initialFilter?: SearchFilter;
  invisible?: boolean; // don't render input control
  label?: string;
  required?: boolean;
  slim?: boolean;
  control?: React.ReactNode;
}
